<template>
  <div class="h-full">
    <div class="flex h-full items-center">
      <vs-button class="px-4" @click="assignOpen = true">Assign</vs-button>
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item @click="openEditView">Edit</vs-dropdown-item>
          <vs-dropdown-item @click="openConfirm()">Delete</vs-dropdown-item>
          <vs-dropdown-item @click="openPreview()">Preview</vs-dropdown-item>
          <vs-dropdown-item v-if="params.colDef.cellRendererParams.type!='report'" @click="attachToCourseModal = true"
            >Attach to courses</vs-dropdown-item
          >
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <div v-if="assignOpen">
      <ReportAssignComponent
      v-if="params.colDef.cellRendererParams.type=='report'"
      :assignOpenModal= "assignOpen"
        :assignType="assignType"
        :dataObj="params.data"
        @assignclose="assignClose"
      /> 
      <AssignComponent
      v-else
      :formName="formName"
      :assignOpenModal= "assignOpen"
        :assignType="assignType"
        :dataObj="params.data"
        @assignclose="assignClose"
      />
    </div>
    <div v-if="attachToCourseModal"> 
      <CourseListingComponent :attachToCourseModal="attachToCourseModal" :details="params.data" :type="params.colDef.cellRendererParams.type" :coursework_id="params.data.id" @attachToCourseModalFalse = "attachToCourseModalFalse" />
    </div>
  </div>
</template>

<script>

import {
  deleteAssignment
} from '@/api/assignment-question'

import CourseListingComponent from './courseListingForCoursework.vue'
import AssignComponent from './AssignComponent.vue'
import ReportAssignComponent from '../../Reports/Template/ReportAssignModal.vue'
//import CourseListingComponent from '@/views/pages/course-builder/ListingComponent/Course/CourseListingComponent.vue'

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  name: 'CellRendererAction',
  components: {
    vSelect,
    flatPickr,
    AssignComponent,
    ReportAssignComponent,
    CourseListingComponent
  },
  mounted () {
    this.formName = this.params.colDef.cellRendererParams.type === 'exam' ? 'Exam' : 'Coursework'
  },
  data () {
    return {

      delete_id:[],

      formName:'',
      attachToCourseModal: false,
      assignOpen: false,
      assignType: 'assign'
    }
  },
  methods: {
    attachToCourseModalFalse () {
      this.attachToCourseModal = false
    },

    assignClose () {
      this.assignOpen = false
    },

    openConfirm () {
      console.log(this.params)

      this.delete_id.length = 0
      this.delete_id[0] = this.params.data.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure, you want to delete this template?',
        accept: this.acceptAlert
      })
    
    },
    acceptAlert () {
      this.deleteAssignment(this.delete_id)
    },
    async deleteAssignment (assignment_id) {

      try {
        const payload = { ids: assignment_id }
        const customer_id = this.$store.getters.customerId
        // const payloadData = payload.forEach(ele => {});

        const response = await deleteAssignment(customer_id, payload)

        if (response.status === 200 || response.status === 202) {
          if (response.data.data.status) {
            this.additionalPopUp = true
            this.nonDeletableItems = response.data.data.nonDeletableEntity.map(item => { return item.title })
          } else {
            this.showSuccessMessage('Success', 'Deleted Successfully', 'success')
          }
        }
        console.log(this.params.colDef)
        this.params.colDef.cellRendererParams.fetchAssignmentList()
        //this.fetchAssignmentList(this.payload)
        // if (this.AssignmentList.length === 0 && !this.query_page.next_page_url) {
        //   this.handlePageChange(this.query_page.current_page - 1)
        // } else {
        //   this.handlePageChange(this.query_page.current_page)
        // }

      } catch (error) {
        // this.showSuccessMessage('Error', 'Failed to delete', 'danger')
      }
    },
    
    openEditView () {
      this.$router.push({
        name: 'Edit QuestionsV2',
        params: {
          assignment_id:this.params.data.id,
          formType: 'Edit',
          type:this.params.colDef.cellRendererParams.type,
          redirection_from:this.params.colDef.cellRendererParams.type === 'report' ? 3 : 2,
          assignmentApplicationType: 'General'
        }
      })
    },
    openPreview () {
     
      this.$router.push({
        name: 'Preview QuestionsV2',
        params: {
          assignment_id:this.params.data.id,
          formType: 'Preview',
          type:this.params.colDef.cellRendererParams.type,
          redirection_from:3,
          assignmentApplicationType: 'General'
        }
      })
    }
  }
}
</script>